import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import {
  createInitialValues,
  createFormValidationFn,
} from 'client/helpers/formikHelpers';

import SrFormikField from 'client/components/SrFormikField';
import ButtonDeprecated, { BUTTON_THEME_YELLOW } from 'client/components/ButtonDeprecated';

const householdBuyersAgentFormFields = [
  {
    id: 'hasBuyersAgent',
    title: 'Has external buyers agent?',
    validations: ['required'],
    type: 'multiple_choice',
    properties: {
      multipleSelection: false,
      choices: [
        {
          label: 'Yes',
          value: true,
        },
        {
          label: 'No',
          value: false,
        },
      ],
    },
  },
  {
    id: 'buyersAgentName',
    title: 'agent name',
    type: 'short_text',
  },
  {
    id: 'buyersAgentPhone',
    title: 'agent phone',
    validations: ['phone'],
    type: 'phone',
  },
  {
    id: 'buyersAgentEmail',
    title: 'agent email',
    validations: ['email'],
    type: 'email',
  },
];

const SrHouseholdUpdateBuyersAgentForm = ({ householdListing, onSubmit }) => (
  <Formik
    validateOnChange
    initialValues={createInitialValues({
      formFields: householdBuyersAgentFormFields,
      defaultValues: householdListing,
    })}
    validate={createFormValidationFn(householdBuyersAgentFormFields)}
    onSubmit={onSubmit}
    render={(formikBag) => (
      <Form>
        {householdBuyersAgentFormFields.map((formField) => (
          <SrFormikField
            key={formField.id}
            formField={formField}
            formikBag={formikBag}
          />
        ))}
        <ButtonDeprecated
          theme={BUTTON_THEME_YELLOW}
          type='submit'
          disabled={!formikBag.isValid}
        >
          save
        </ButtonDeprecated>
      </Form>
    )}
  />
);

SrHouseholdUpdateBuyersAgentForm.propTypes = {
  householdListing: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

SrHouseholdUpdateBuyersAgentForm.displayName = 'SrHouseholdUpdateBuyersAgentForm';

export default SrHouseholdUpdateBuyersAgentForm;
